import * as StyleFunctions from '../utilities/StyleFunctions';
import AllContents from './AllContents';
import React, {useEffect, useRef} from 'react';

function App(props) {

  var thisCard = props.thisCard;
  var thisCardPath =  props.thisCardPath;

  var allStyles = props.allStyles;
  var currentList = props.currentList;
  var internalVariables = props.internalVariables;
  var width = props.width;
  var height = props.height;
  var inputValues = props.inputValues;
  var ownVariables = props.ownVariables;
  var urlParamsForExecution = props.urlParamsForExecution;
  var urlHeader = props.urlHeader;
  var clickEditItem = props.clickEditItem;
  var interactionFn = props.interactionFn;
  var doAScreenRef = props.doAScreenRef;

  var upwardInfo = props.upwardInfo;
  var setInputValues = props.setInputValues;
  var editPieces = props.editPieces;
  var itemEdited = props.itemEdited;
  var setItemEdited = props.setItemEdited;
  var setIsClickingOnContentDiv = props.setIsClickingOnContentDiv;
  var isClickingOnContentDiv = props.isClickingOnContentDiv;
  var addWhereText = props.addWhereText;
  var potentiallyAddWhichItem = props.potentiallyAddWhichItem;
  var hoveringWhere = props.hoveringWhere;
  var actHoveringWhere = props.actHoveringWhere;
  var organicChanges = props.organicChanges;
  var userNos = props.userNos;
  var userID = props.userID;
  var popUps = props.popUps;
  var setPopUps = props.setPopUps;
  var screenSelectionChoices = props.screenSelectionChoices;
  var setScreenSelectionChoices = props.setScreenSelectionChoices;

  var toAddUpwardInfo = props.toAddUpwardInfo;
  var divClass = props.divClass;
  var detailClass = props.detailClass;
  var summaryClass = props.summaryClass;
  var flashHighlight = props.flashHighlight;
  var chains = props.chains;
  var lastEdited = props.lastEdited;
  var counter = props.counter;

  var allStylesX = StyleFunctions.evaluateStyleR('SUMMARYDIV', thisCard.s, thisCardPath.concat(['s']), currentList, internalVariables, width, height, upwardInfo.concat(toAddUpwardInfo), inputValues, ownVariables, urlParamsForExecution, urlHeader, chains);
  var summaryStyle = {};
  summaryStyle.fontFamily = allStylesX.fontFamily;

  const ref1 = useRef();

  useEffect(()=>{
    doAScreenRef(ref1, thisCardPath);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  function clickFn2(e){ //this should not be used if there is doInteraction, but just in case we wrap up setItemClicked.
    if (clickEditItem){
      clickEditItem({t:'item', path:thisCardPath})(e); //for now, we use v as the primary identifier because it's easier to use. p is used so that we can trace back upwards and do the stuff for card overall. 
    }else{
      e.stopPropagation();
    }
  } 

  //put in div style;

  var stylesToAdd1 = {color: allStyles.color, backgroundColor: allStyles.backgroundColor};
  if (allStyles.detailsStyle === 'One' || allStyles.detailsStyle === 'Two'){
    stylesToAdd1.border = '1px solid ' + allStyles.color;
  }else if (allStyles.detailsStyle === 'Three' || allStyles.detailsStyle === 'Four'){
    stylesToAdd1.borderTop = '1px solid ' + allStyles.color;
  }
  var x = <AllContents userID={userID} chains={chains} height={height} width={width} currentList={currentList} internalVariables={internalVariables} interactionFn={interactionFn} inputValues={inputValues} setInputValues={setInputValues} itemEdited={itemEdited} setItemEdited={setItemEdited} thisItem={thisCard} itemInfoPath={thisCardPath} stylesToAdd={{}} editPieces={editPieces} needToShowError={true} clickEditItem={clickEditItem} addClassNames={divClass} dragStuff={false} parentalType={'SUMMARY'} setIsClickingOnContentDiv={setIsClickingOnContentDiv} isClickingOnContentDiv={isClickingOnContentDiv} upwardInfo={upwardInfo.concat(toAddUpwardInfo)} addWhereText={addWhereText} potentiallyAddWhichItem={potentiallyAddWhichItem} organicChanges={organicChanges} userNos={userNos} hoveringWhere={hoveringWhere} actHoveringWhere={actHoveringWhere} screenSelectionChoices={screenSelectionChoices} setScreenSelectionChoices={setScreenSelectionChoices} popUps={popUps} setPopUps={setPopUps} ownVariables={ownVariables} doAScreenRef={doAScreenRef}  flashHighlight={flashHighlight} urlParamsForExecution={urlParamsForExecution} urlHeader={urlHeader} lastEdited={lastEdited} counter={counter}/>

  return <details ref={ref1} className = {detailClass} style={stylesToAdd1} onClick={clickFn2}>
            <summary className={summaryClass} style={summaryStyle}>
              {allStylesX.text}
            </summary>
            {x}
          </details>    
}
//




export default App;
